import * as React from 'react'
import classNames from 'classnames'
import UIMessages from '../../utils/ui-messages'

interface IProps {
  status: string
}
class StatusTag extends React.Component<IProps> {
  public render() {
    const { status } = this.props
    const statusText = UIMessages.tripStatusMap[status] || 'No Status'
    return (
      <span title={UIMessages.tripStatusHoverMessageMap[status]} className={this.statusClasses()}>
        {statusText}
      </span>
    )
  }

  private statusClasses = () => {
    const { status } = this.props
    return classNames('rounded p03 bold bwidth1 font-small uppercase', {
      'border-dark-yellow bg-yellow font-white': status === 'REQUESTED',
      'border-grey bg-light-grey font-white': status === 'WILL_CALL',
      'border-blue bg-blue font-white': status === 'ACCEPTED',
      'border-dark-blue bg-dark-blue font-white': status === 'AT_PICK_UP',
      'border-green bg-light-green font-white': this.isActive(status),
      'border-orange bg-light-orange font-white': this.isAlert(status),
      'border-red bg-light-red font-white': this.isError(status),
      'border-grey4': this.isCompleted(status),
      'border-light-grey4 bg-light-grey font-dark-grey': status === 'CANCELLED'
    })
  }

  private isActive = (status: string) => {
    return [
      'REQUESTED',
      'DRIVING_TO_PICK_UP',
      'PICKED_UP',
      'AT_DROP_OFF',
      'SCHEDULE_REQUESTED',
      'SCHEDULE_ACCEPTED',
      'SCHEDULED',
      'DISPATCH_ASSIGNED_DRIVER'
    ].includes(status)
  }

  private isCompleted = (status: string) => {
    return ['MANUALLY_COMPLETED', 'COMPLETED'].includes(status)
  }

  private isError = (status: string) => {
    return ['INTEGRATION_FAILED', 'BOOKING_FAILED', 'WAITING'].includes(status)
  }

  private isAlert = (status: string) => {
    return ['REJECTED', 'NO_RESPONSE_OPERATOR', 'DRIVER_CANCELLED'].includes(status)
  }
}

export default StatusTag



// WEBPACK FOOTER //
// ./src/components/ui/StatusTag.tsx